import React, { useState } from 'react'
import { useVendorsSourceSummary } from '../../hooks/queries/sourceSummary'
import SourceAccordians from './components/SourceAccordian/SourceAccordians'
import { useAllVendors } from '../../hooks/queries/allVendors'
import VendorsSourceData from './sections/VendorsSourceData'
import AllVendorsTable from '../sourceData/components/AllVendorsTable'
import { useQueryClient } from 'react-query'
import Loading from '../../components/Loading'
import { useAuth0 } from '@auth0/auth0-react'

export default function VendorsPage() {
  const [sheetData, setSheetData] = useState({})
  const [expanded, setExpanded] = useState(false)

  const sourceSummaryType = 'vendorSummary'
  const sourceSummaryQueryKey = 'vendorSourceSummary'
  const dataSummaryQueryKey = 'vendorTable'
  const pageDataType = 'vendors'

  const { user } = useAuth0()

  const { isFetching: iFSourceData } = useVendorsSourceSummary(sourceSummaryQueryKey, sourceSummaryType, {
    setSheetData,
  })

  const {
    isLoading: iLTableData,
    isErroxr: iETableData,
    isFetching: iFTableData,
    data: vendorTableData,
  } = useAllVendors(dataSummaryQueryKey, 1000, 0, user?.email)

  const queryClient = useQueryClient()
  const refetchData = () => {
    queryClient.refetchQueries([sourceSummaryQueryKey])
    queryClient.refetchQueries([dataSummaryQueryKey])
  }

  const refreshTableData = () => {
    queryClient.refetchQueries([dataSummaryQueryKey])
  }

  const setExpand = (val) => {
    setExpanded(val)
  }

  const sourceDataSources = iFSourceData
    ? []
    : [<VendorsSourceData refetchData={refetchData} uploadSummary={sheetData} key={0} setExpand={setExpand} />]

  const clearSheetData = () => {
    setSheetData({})
  }

  const tableData = iLTableData || iETableData || iFTableData ? [] : vendorTableData

  return (
    <>
      {iFSourceData ? (
        <Loading />
      ) : (
        <SourceAccordians
          label={'Vendor'}
          sources={sourceDataSources}
          refetchData={refetchData}
          clearSheetData={clearSheetData}
          displayComp={<AllVendorsTable data={tableData} refreshTableData={refreshTableData} />}
          sourceSummaryQueryKey={sourceSummaryQueryKey}
          dataSummaryQueryKey={dataSummaryQueryKey}
          pageDataType={pageDataType}
          toExpand={expanded}
        />
      )}
    </>
  )
}
